import React, {useEffect, useState, useRef} from 'react';
import {Checkbox} from '@montana/shared/form';
import {SvgIcon} from '@montana/shared/svg-icon';
import {getCookieItem, setCookieItem} from '@montana/helpers/browser-cookie.helper';
import cx from 'clsx';
import {useSettings} from '@montana/containers/settings/settings.container';
import {TabletLandscapeAndLarger} from '@montana/shared/responsive';

export interface IInfoToolboxProps {
    id: string;
    headline?: string;
    content?: string;
    label?: string;
    appearTimeMs: number;
}

export const InfoToolbox: React.FC<IInfoToolboxProps> = React.memo(({id, headline, content, appearTimeMs, label}: IInfoToolboxProps) => {

    const cookieKey = `infoBox-${id}`;
    const [infoBoxDisappear, setInfoBoxDisappear] = useState(false);
    const [infoBoxVisible, setInfoBoxVisible] = useState(true);
    const [hideInfoToolbox, setHideInfoToolbox] = useState(true);
    const { setInfoToolbox, infoToolboxs } = useSettings();
    const infoToolboxContainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const infoBox = infoToolboxContainer.current;
        if (!infoBox) return;

        const root = infoBox.ownerDocument;

        const handler = (e: MouseEvent) => {
            const isWithinToolbox = e.target === infoBox || infoBox.contains(e.target as Node);
            if (!isWithinToolbox) {
                handleCloseInfoBox();
            }
        };

        root.addEventListener("click", handler, { passive: true });
        return () => root.removeEventListener("click", handler);
    }, []);

    useEffect(() => {
        // display infobox after 2 sec
        const cookieValue = getCookieItem(cookieKey);
        const hideInfoToolbox = infoToolboxs.includes(cookieKey);
        if (!cookieValue && !hideInfoToolbox) {
            setTimeout(() => {
                setHideInfoToolbox(false);
            }, appearTimeMs);
            return
        }
        if (cookieValue) {
            setInfoBoxVisible(JSON.parse(cookieValue));
        }
    }, []);

    const handleCloseInfoBox = () => {
        setInfoBoxVisible(false);
        setInfoToolbox(cookieKey);
        if (infoBoxDisappear) {
            setCookieItem(cookieKey, JSON.stringify(!infoBoxDisappear))
        }
    }

    return (
        <>
            {infoBoxVisible && (headline && content && label) && (
                <TabletLandscapeAndLarger>
                    <div className={cx('info-toolbox', {'info-toolbox--disappear':hideInfoToolbox})} ref={infoToolboxContainer}>
                        <header className="info-toolbox__headline">{headline}</header>
                        <p className="info-toolbox__content">{content}</p>
                        <div className="info-toolbox__hide-toolbox-always">
                            <Checkbox onCheck={() => setInfoBoxDisappear(!infoBoxDisappear)}
                                isChecked={infoBoxDisappear}
                                inlineLabel={true}
                                className="info-toolbox__checkbox">{label}
                            </Checkbox>
                        </div>
                        <button type="button" className="info-toolbox__close" onClick={() => handleCloseInfoBox()}>
                            <SvgIcon iconName='close'/>
                        </button>
                    </div>
                </TabletLandscapeAndLarger>
            )}
        </>
    )
});
